import { PauseCancelReasonDto } from "@intelligems/ig-types";

export const getPauseCancelReasons = (
  reasons: PauseCancelReasonDto[]
): PauseCancelReasonDto[] => {
  return reasons
    .map((reason) => {
      if (reason.checked) {
        return {
          ...reason,
          items: reason.items.filter((item) => item.checked),
        };
      }
      return null;
    })
    .filter((r): r is PauseCancelReasonDto => r !== null);
};
